import withInputFields from "../../helpers/inputfields";
import withReactiveFields from "../../helpers/reactivefields";
import { getValueAtPath, withProperties } from "../../../../utils";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";

import InitView from "./views/init";
import ConfirmView from "./views/confirm";
import SuccessView from "../../common/success";

const METHOD = '1voucher';
const METHOD_NAME = '1Voucher';
const CHARGE_MODE = 0;

const VIEWS = [ InitView, ConfirmView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the form (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      InitView && InitView.activate();
    });

    getChargeFee();
  };
}

function getChargeData() {
  return ({
    country: 'ZA',
    is_flash_voucher: true,
    payment_type: '1voucher'
  });
}

function getViewsContext(data, store) {
  const REACTIVE_FIELDS = ['CHANGE_VOUCHER'];
  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  $context.$subscribe('CHANGE_VOUCHER', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue)) {
        currentValue === false
          ? (SuccessView && SuccessView.activate.call($context))
          : (ConfirmView && ConfirmView.activate());
      }
    }, 0);
  });

  withInputFields($context, {
    voucher: null,
    phone: getValueAtPath(data, 'phone') || null
  });

  return withProperties($context, {
    INIT_VIEW: callback => {
      InitView && InitView.activate(callback);
    }
  });
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
